import React, { useEffect, useRef, useState } from 'react'
import TopBar from './TopBar'
import { Autocomplete, Dialog, IconButton, TextField, Tooltip } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home';
import { useDispatch, useSelector } from 'react-redux';
import { setBtnSelected, setCustomerWallet, setSelfDeliveryKm, setSelfDeliveryCharge } from './topBarSliceBilling';
import "./billingPayment.css"
import Calculator from '../../../../Single Components/Calculator';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import axios from 'axios';
import { getCurrentTime, getTimeDifference, today } from '../../../../../Js/Date';
import { setDialogBox, setErrorSnack, setSuccessSnack, setOrderIdInPOS, setSnackMsg } from '../Slice/billingScreenSlice';
import { finalPaymentPOSApiCall, refundPaymentApiCall, refundUpdatePaymentApiCall } from '../API/billingPaymentSection';
import { listHeldOrders, listOrdersForBillingAPI } from '../API/viewOrderSection';
import { setInputCalculator } from '../Slice/calculatorSlice';
import walletIcon from "../image/wallet (5).png"
import Swal from 'sweetalert2';
import paymentEmpty from "../image/paytype-01.png"
import UpdateOrderAuth from './UpdateOrderAuth';
import { errorSnackMsg } from '../../../../Custom Hooks/SnackkBarUtilities';
import PaymentQrComponent from '../../../../Single Components/ActionButtons/PaymentQrComponent';
import { getDiscountAPICall } from '../../../../../API/Settings/Discount/discountAPI';
import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';
import { sendWhatsAppMessageAPI } from '../../../PointOfSale/Configuration/BranchSettings/BranchSettingsAPI';
import PosReceiptTemplate from '../../../components/template/posReceipt/PosReceiptTemplate';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { HEADERS } from '../../../../../API/UrlAndPaths';
import { createUpiPaymentRequest, startPaymentPolling } from '../API/upiPaymentAPI';
import Lottie from 'react-lottie';
import cashLottie from '../../../../../lottie/Money.json';
import cardLottie from '../../../../../lottie/CreditCard.json';
import bankLottie from '../../../../../lottie/BANK.json';
import upiLottie from '../../../../../lottie/UPI.json';
import chequeLottie from '../../../../../lottie/Bankcheque.json';

function BillingPayment({ 
    setCustomerDisplayQRInfo, 
    upiPaymentSuccessData, 
    upiPaymentFailedData,
    setUpiPaymentSuccessData,
    setUpiPaymentFailedData 
}) {

    const dispatch = useDispatch()

    const decimalPosition = localStorage.getItem("decimalPosition")
    let invoicePrint = useRef();

    // redux states
    const userInfo = useSelector((state) => state.loginResponseSlice.value);
    const { customer, defaultCustomer, customerWallet, selfDeliveryCharge, selfDeliveryKm, billType, aggregator } = useSelector((state) => state.topBarSliceBilling)
    // console.log(customer,"customerbillingpayment")
    const { singleOrderInfo, orderIdForPos, branchId, dialogOpen } = useSelector((state) => state.billingScreenSlice);
    const { currencyDetails } = useSelector((state) => state.mainDashBoardSlice)
    const userBranchId = userInfo?.branchPk;
    const { floors } = useSelector((state) => state.addSeatSlice);
    const branchSettingsView = useSelector((state) => state.branchSettingsSliceNew.rowData);
    const { inputValueCalculator } = useSelector((state) => state.calculatorSlice);


    const shiftStatus = useSelector((state) => state.shiftStatusSlice.value);
    const posSettings = useSelector((state) => state.posSettingSlice.apiResList)
    const roundOff = posSettings?.enableRoundOff || false;

    const billingPaymentTypeView = (posSettings?.billingPaymentTypeView || localStorage.getItem('billingPaymentTypeView') || 'list');

    const paymentTypesForBranch = useSelector((state) => state.newBillingSlice.paymentTypeList)
    // console.log(paymentTypesForBranch, "paymentTypesForBranchpaymentTypesForBranch")
    const { authPassWord, branchConfigurationList } = useSelector((state) => state.newBillingSlice);
    const discountData = useSelector((state) => state.discountSlice.value)
    // console.log(discountData);
console.log(branchConfigurationList, "branchConfigurationListbillingpayment")
    const cardManual = useSelector((state) => state.cardManualSlice.value);

    const walletStatus = posSettings?.activeWalletStatus;
    // console.log(walletStatus,"walletStatusbillingpayment")
    const activeWalletJournel = posSettings?.activeWallet?.activeWalletJournel

    // useStates
    const paymentFormInitialStates = {
        deliveryCharge: 0.00,
        pkgCharge: 0.00,
        rewardPoints: "",
        discount: 0,
        amountTotal: null,
        paidAmount: null,
        wallet: "",
        credit: "",
        totalAmt: 0,
        totalExcl: 0,
        totalIncl: 0,
        change: 0,
        balance: 0,
        changeInWallet: null,
        roundOffValue: 0,
        isDiscountPercentage: false, // New
    }
    const [paymentForm, setPaymentForm] = useState(paymentFormInitialStates)

    const [paymentsTypeArray, setPaymentsTypeArray] = useState([])
    const [paymentSelectedArray, setPaymentSelectedArray] = useState([])
    const [initialRefresh, setInitialRefresh] = useState(true)
    const [selectedPaymentRow, setSelectedPaymentRow] = useState(null)
    const [kmRangeError, setKmRangeError] = useState(null) // Track km range validation error
    
    // Promo code states
    const [promoCode, setPromoCode] = useState('')
    const [promoLoading, setPromoLoading] = useState(false)
    const [appliedPromo, setAppliedPromo] = useState(null) // { offer, discountAmount, message }
    
    // UPI Payment polling state
    const [upiTransactionId, setUpiTransactionId] = useState(null)
    const [upiPollingActive, setUpiPollingActive] = useState(false)
    const stopUpiPollingRef = useRef(null)
    const paymentButtonRef = useRef(null) // Ref to auto-click payment button

    // const paymentFormOnChange = (key, value) => {
    //     const validInput = value.replace(/[^0-9.]/g, '');
    //     setPaymentForm((prevForm) => {
    //         let amountTotal = singleOrderInfo?.totalExclusive + singleOrderInfo?.subTotal;
    //         if (key === "deliveryCharge") {
    //             amountTotal = (amountTotal + Number(validInput) + Number(prevForm.pkgCharge)) - Number(prevForm.discount);
    //         } else if (key === "pkgCharge") {
    //             amountTotal = (amountTotal + Number(validInput) + Number(prevForm.deliveryCharge)) - Number(prevForm.discount);
    //         } else if (key === "discount") {
    //             amountTotal = (amountTotal - Number(validInput)) + (Number(prevForm.deliveryCharge) + Number(prevForm.pkgCharge));
    //         }

    //         if (amountTotal < 0) {
    //             errorSnackMsg("Total amount is less than zero!!")
    //             return prevForm
    //         }
    //         let roundOffValue = 0;
    //         if (roundOff) {
    //             const rounded = calculateRoundedAmount(amountTotal);
    //             amountTotal = rounded.roundedAmount;
    //             roundOffValue = rounded.roundOffValue;
    //         }

    //         return {
    //             ...prevForm,
    //             [key]: Number(validInput),
    //             amountTotal,
    //             roundOffValue
    //         };
    //         // else {
    //         //     return {
    //         //         ...prevForm,
    //         //         [key]: Number(validInput),
    //         //         amountTotal
    //         //     };

    //         // }
    //     });

    // }
    const paymentFormOnChange = (key, value) => {
        const validInput = value.replace(/[^0-9.]/g, '');

        setPaymentForm((prevForm) => {
            const baseAmount = singleOrderInfo?.totalExclusive + singleOrderInfo?.subTotal;

            const deliveryCharge = key === "deliveryCharge" ? Number(validInput) : Number(prevForm.deliveryCharge);
            const pkgCharge = key === "pkgCharge" ? Number(validInput) : Number(prevForm.pkgCharge);

            let discountInput = key === "discount" ? Number(validInput) : Number(prevForm.discount);
            let discountAmount = 0;
            let percentageDiscountAmount = prevForm.percentageDiscountAmount;

            const isPercentage = prevForm.isDiscountPercentage;

            // ✅ Only apply restriction if discountData is truthy
            if (key === "discount" && discountData?.discountAmount) {
                if (isPercentage) {
                    if (discountInput > discountData?.discountAmount) {
                        errorSnackMsg(`You can't enter more than ${discountData?.discountAmount}%`);
                        return prevForm;
                    }
                } else {
                    const maxAllowedAmount = (baseAmount * discountData?.discountAmount) / 100;
                    if (discountInput > maxAllowedAmount) {
                        errorSnackMsg(`Discount can't exceed ₹${maxAllowedAmount.toFixed(2)} (${discountData?.discountAmount}%)`);
                        return prevForm;
                    }
                }
            }

            // ✅ Calculate actual discount
            if (isPercentage) {
                discountAmount = (baseAmount * discountInput) / 100;
                percentageDiscountAmount = discountAmount;
            } else {
                discountAmount = discountInput;
                percentageDiscountAmount = 0;
            }

            let amountTotal = baseAmount + deliveryCharge + pkgCharge - discountAmount;

            if (amountTotal < 0) {
                errorSnackMsg("Total amount is less than zero!!");
                return prevForm;
            }

            let roundOffValue = 0;
            if (roundOff) {
                const rounded = calculateRoundedAmount(amountTotal);
                amountTotal = rounded.roundedAmount;
                roundOffValue = rounded.roundOffValue;
            }

            return {
                ...prevForm,
                [key]: Number(validInput),
                amountTotal,
                roundOffValue,
                percentageDiscountAmount
            };
        });
    };


    const calculateRoundedAmount = (amount) => {
        const rounded = Math.round(amount);
        const roundOffValue = parseFloat((rounded - amount));
        return {
            roundedAmount: rounded,
            roundOffValue: roundOffValue
        };
    };

    const cusWalletObjInitial = {
        journalId: activeWalletJournel,
        journalName: "Customer Wallet",
        type: "wallet",
        _id: null,
        walletBalance: 0
    }
    const [cusWalletObj, setCusWalletObj] = useState(cusWalletObjInitial)

    const getPaymentTypeKey = (type) => String(type || '').toLowerCase();
    const getPaymentTypeAnimation = (type) => {
        const t = getPaymentTypeKey(type);
        if (t === 'cash') return cashLottie;
        if (t === 'card') return cardLottie;
        if (t === 'bank') return bankLottie;
        if (t === 'upi') return upiLottie;
        if (t === 'cheque') return chequeLottie;
        return cashLottie;
    };
    const getLottieOptions = (animationData, play) => ({
        loop: !!play,
        autoplay: !!play,
        animationData,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
    });
    const renderPaymentLottie = (type, size, play) => (
        <Lottie
            options={getLottieOptions(getPaymentTypeAnimation(type), play)}
            height={size}
            width={size}
            isStopped={!play}
            isPaused={!play}
            isClickToPauseDisabled
        />
    );
    const findSelectedPaymentIndex = (row) => {
        if (!row) return -1;
        const rowType = getPaymentTypeKey(row?.type);
        const rowJournalId = row?.journalId;
        return paymentSelectedArray.findIndex((p) => {
            const pType = getPaymentTypeKey(p?.type);
            if (rowJournalId && p?.journalId) return p?.journalId === rowJournalId;
            return pType === rowType && (p?.journalName || '').toLowerCase() === (row?.journalName || '').toLowerCase();
        });
    };
    const isPaymentTypeSelected = (row) => {
        if (!row) return false;
        const rowType = getPaymentTypeKey(row?.type);
        const rowJournalId = row?.journalId;
        return paymentSelectedArray.some((p) => {
            const pType = getPaymentTypeKey(p?.type);
            if (rowJournalId && p?.journalId) return p?.journalId === rowJournalId;
            return pType === rowType && (p?.journalName || '').toLowerCase() === (row?.journalName || '').toLowerCase();
        });
    };

    // adding payment type in array
    const paymentTypeClick = (obj) => async () => {
        const existingIndex = findSelectedPaymentIndex(obj);
        if (existingIndex !== -1) {
            const newArray = [...paymentSelectedArray];
            const removed = newArray.splice(existingIndex, 1)[0];
            setPaymentSelectedArray(newArray);

            // If UPI deselected, stop polling and close customer display QR
            if (removed?.type === "upi") {
                if (stopUpiPollingRef.current) {
                    stopUpiPollingRef.current();
                }
                setUpiPollingActive(false);
                setUpiTransactionId(null);
                setCustomerDisplayQRInfo && setCustomerDisplayQRInfo((prev) => ({
                    ...(prev || {}),
                    open: false,
                    status: 'pending'
                }));
            }
            return;
        }

        let paidAmount = 0
        if (obj.type === "wallet") {
            paidAmount = (Number(paymentForm.balance) > Number(obj.walletBalance)) ? (obj?.walletBalance) : paymentForm.balance
            let walletBal = cusWalletObj.walletBalance - Number(paidAmount)
            setCusWalletObj({ ...cusWalletObj, walletBalance: walletBal })

        } else {
            paidAmount = paymentForm.balance
        }
        if (obj.type === "wallet" && paymentSelectedArray.some(obj => obj.type === "wallet")) {
            dispatch(setSnackMsg("Wallet payment type already exist!!"))
            dispatch(setErrorSnack(true))
        } else {
            const updatedObj = { ...obj, paidAmt: Number(paidAmount)?.toFixed(decimalPosition) || 0 }
            setPaymentSelectedArray([...paymentSelectedArray, updatedObj])
            
            // Show QR on customer display for UPI payment type and start polling
            if (obj.type === "upi" && obj.upiId) {
                setCustomerDisplayQRInfo({
                    open: true,
                    bankAccount: obj.upiId,
                    payeeName: obj.bankingName || '',
                    amount: Number(paidAmount) || 0,
                    currency: currencyDetails?.symbol || 'AED',
                    status: 'pending'
                });
                
                // Start UPI payment polling only if API auto-verification is enabled
                if (obj.upiApiEnabled && obj.upiApiConfig?.merchantId && obj.upiApiConfig?.apiKey) {
                    await startUpiPaymentPolling(obj, Number(paidAmount));
                } else {
                    console.log('📱 UPI API not configured - manual verification required');
                }
            }
        }

    }
    
    // Start UPI payment polling for automatic payment detection
    const startUpiPaymentPolling = async (paymentType, amount) => {
        try {
            // Stop any existing polling
            if (stopUpiPollingRef.current) {
                stopUpiPollingRef.current();
            }
            
            console.log('🔄 Starting UPI payment polling...', { 
                provider: paymentType.upiProvider, 
                amount, 
                orderId: orderIdForPos 
            });
            
            // Create UPI payment request with UPI config from payment type
            const result = await createUpiPaymentRequest({
                amount,
                orderId: orderIdForPos,
                branchId: userBranchId,
                note: `Order ${orderIdForPos}`,
                upiConfig: {
                    upiId: paymentType.upiId,
                    bankingName: paymentType.bankingName,
                    provider: paymentType.upiProvider,
                    // Use UPI API config if enabled, otherwise fall back to POS machine config
                    merchantId: paymentType.upiApiEnabled ? paymentType.upiApiConfig?.merchantId : paymentType.posMachineConfig?.merchantId,
                    apiKey: paymentType.upiApiEnabled ? paymentType.upiApiConfig?.apiKey : paymentType.posMachineConfig?.apiKey,
                    apiSecret: paymentType.upiApiEnabled ? paymentType.upiApiConfig?.apiSecret : paymentType.posMachineConfig?.apiSecret,
                    apiUrl: paymentType.upiApiEnabled ? paymentType.upiApiConfig?.apiUrl : paymentType.posMachineConfig?.apiUrl
                }
            });
            
            if (!result.success) {
                console.log('⚠️ UPI payment request failed, manual verification required');
                return;
            }
            
            setUpiTransactionId(result.transactionId);
            
            // If requires manual verification, don't poll
            if (result.requiresManualVerification) {
                console.log('📱 UPI payment requires manual verification');
                return;
            }
            
            setUpiPollingActive(true);
            
            // Start polling for payment status
            stopUpiPollingRef.current = startPaymentPolling(
                result.transactionId,
                // On Success - Auto trigger payment
                (statusResult) => {
                    console.log('✅ UPI Payment Success detected!', statusResult);
                    setUpiPollingActive(false);
                    
                    // Update customer display to show success
                    setCustomerDisplayQRInfo(prev => ({
                        ...prev,
                        status: 'success',
                        amount: amount
                    }));
                    
                    // Auto-click the payment button after a short delay
                    setTimeout(() => {
                        if (paymentButtonRef.current) {
                            console.log('🔘 Auto-clicking payment button...');
                            paymentButtonRef.current.click();
                        }
                    }, 500);
                },
                // On Failed
                (statusResult) => {
                    console.log('❌ UPI Payment Failed', statusResult);
                    setUpiPollingActive(false);
                    setCustomerDisplayQRInfo(prev => ({
                        ...prev,
                        status: 'declined'
                    }));
                },
                // On Timeout
                () => {
                    console.log('⏰ UPI Payment polling timeout');
                    setUpiPollingActive(false);
                }
            );
            
        } catch (error) {
            console.error('❌ UPI polling error:', error);
            setUpiPollingActive(false);
        }
    }
    
    // Cleanup UPI polling on unmount
    useEffect(() => {
        return () => {
            if (stopUpiPollingRef.current) {
                stopUpiPollingRef.current();
            }
        };
    }, []);

    // Handle UPI payment success from webhook (via socket)
    useEffect(() => {
        if (upiPaymentSuccessData && upiPaymentSuccessData.transactionId === upiTransactionId) {
            console.log('✅ UPI Payment Success from webhook - auto-triggering payment!', upiPaymentSuccessData);
            
            // Stop any active polling
            if (stopUpiPollingRef.current) {
                stopUpiPollingRef.current();
            }
            setUpiPollingActive(false);
            
            // Update customer display to show success
            setCustomerDisplayQRInfo(prev => ({
                ...prev,
                status: 'success',
                amount: upiPaymentSuccessData.amount
            }));
            
            // Auto-click the payment button after a short delay
            setTimeout(() => {
                if (paymentButtonRef.current) {
                    console.log('🔘 Auto-clicking payment button from webhook success...');
                    paymentButtonRef.current.click();
                }
            }, 500);
            
            // Clear the success data
            setUpiPaymentSuccessData && setUpiPaymentSuccessData(null);
        }
    }, [upiPaymentSuccessData, upiTransactionId]);

    // Handle UPI payment failure from webhook (via socket)
    useEffect(() => {
        if (upiPaymentFailedData && upiPaymentFailedData.transactionId === upiTransactionId) {
            console.log('❌ UPI Payment Failed from webhook', upiPaymentFailedData);
            
            // Stop any active polling
            if (stopUpiPollingRef.current) {
                stopUpiPollingRef.current();
            }
            setUpiPollingActive(false);
            
            // Update customer display to show declined
            setCustomerDisplayQRInfo(prev => ({
                ...prev,
                status: 'declined'
            }));
            
            // Clear the failed data
            setUpiPaymentFailedData && setUpiPaymentFailedData(null);
        }
    }, [upiPaymentFailedData, upiTransactionId]);

    // card type selecting
    const paymentCardOnchange = (key) => (e, newValue) => {
        if (newValue === null) {
            // const newArray=paymentSelectedArray?.filter(obj=>obj.journalId !== key?.journalId)
            // setPaymentSelectedArray(newArray)
        } else {
            setPaymentSelectedArray((prevArray) => {
                // const newArray = prevArray?.filter(obj => obj._id !== newValue?._id);
                const updatedValue = {
                    ...newValue,
                    type: "card",
                    paidAmt: (Number(paymentForm.balance)?.toFixed(decimalPosition) || 0),
                    journalId: key?.journalId
                };
                return [...prevArray, updatedValue];
            });
        }
    }

    // deleting selected payment type array
    const removePaymentType = (index) => () => {
        let newArray = [...paymentSelectedArray];
        newArray.splice(index, 1);

        setPaymentSelectedArray(newArray);
    }

    const paidAmountChange = (index) => (e) => {
        let validInput = e.target.value.replace(/[^0-9.]/g, '');
        const updatedData = paymentSelectedArray.map((r, i) => {
            if (i === index) {
                if (r.type === "wallet" && Number(validInput) > customerWallet?.walletBalance) {
                    dispatch(setSnackMsg(`available customer wallet amount is ${customerWallet?.walletBalance}`))
                    dispatch(setErrorSnack(true))
                    validInput = customerWallet?.walletBalance
                }
                return { ...r, paidAmt: validInput };
            } else {
                return r
            }
        })


        setPaymentSelectedArray(updatedData);
    }

    const approvalNoOnChange = (index) => (e) => {
        const updatedData = paymentSelectedArray.map((r, i) => {
            if (i === index) {
                return { ...r, approvalCode: e.target.value };
            } else {
                return r
            }
        })
        setPaymentSelectedArray(updatedData);
    }

    const amountAndWalletChange = (key) => (e) => {
        if (key === "wallet") {
            let changeAmt = Math.max(Number(paymentForm.change) - Number(e.target.value), 0)
            setPaymentForm({ ...paymentForm, wallet: e.target.value, changeInWallet: changeAmt?.toFixed(decimalPosition) })
        }
    }

    // calculate change and balance
    ////////////////////correct way////////////////
    // const calculateCHangeAndBal = () => {

    //     let paidAmt = Number(paymentForm.paidAmount)?.toFixed(decimalPosition)
    //     let totalAmount = Number(paymentForm.amountTotal)?.toFixed(decimalPosition)

    //     if (roundOff) {
    //         // const roundedPaid = calculateRoundedAmount(paidAmt);
    //         // paidAmt = roundedPaid.roundedAmount;

    //         const roundedTotal = calculateRoundedAmount(totalAmount);
    //         totalAmount = roundedTotal.roundedAmount;
    //     }

    //     let changeAmt = Math.max(paidAmt - totalAmount, 0)
    //     let balanceAmt = Math.max(totalAmount - paidAmt, 0)
    //     setPaymentForm({
    //         ...paymentForm,
    //         change: changeAmt?.toFixed(decimalPosition),
    //         balance: balanceAmt?.toFixed(decimalPosition)
    //     })
    // }
    /////////////////////////////////////////////////

    // Example: In calculateCHangeAndBal
    const calculateCHangeAndBal = () => {
        let paidAmt = Number(paymentForm.paidAmount);
        // console.log("paidAmt before toFixed:", paidAmt);
        paidAmt = paidAmt?.toFixed(decimalPosition);
        // console.log("paidAmt after toFixed:", paidAmt);

        let totalAmount = Number(paymentForm.amountTotal);
        // console.log("totalAmount before toFixed:", totalAmount);
        totalAmount = totalAmount?.toFixed(decimalPosition);
        // console.log("totalAmount after toFixed:", totalAmount);

        if (roundOff) {
            const roundedTotal = calculateRoundedAmount(totalAmount);
            totalAmount = roundedTotal.roundedAmount;
        }

        let changeAmt = Math.max(paidAmt - totalAmount, 0);
        let balanceAmt = Math.max(totalAmount - paidAmt, 0);

        // console.log("changeAmt before toFixed:", changeAmt);
        let changeAmtFixed = changeAmt?.toFixed(decimalPosition);
        // console.log("changeAmt after toFixed:", changeAmtFixed);

        // console.log("balanceAmt before toFixed:", balanceAmt);
        let balanceAmtFixed = balanceAmt?.toFixed(decimalPosition);
        // console.log("balanceAmt after toFixed:", balanceAmtFixed);

        setPaymentForm({
            ...paymentForm,
            change: changeAmtFixed,
            balance: balanceAmtFixed
        })
    }

    const clearPaymetArrayFunction = () => {
        let filteredArray = paymentSelectedArray.filter((obj) => (!obj.change === true))
        setPaymentSelectedArray(filteredArray)
    }

    // WhatsApp payment link sending function - sends payment link only (not PDF)
    // When user clicks WhatsApp icon on UPI payment type
    const sendUpiQrToWhatsApp = async (upiData) => {
        if (!branchConfigurationList?.enableWhatsApp) {
            console.log('WhatsApp not enabled in branch settings');
            dispatch(setSnackMsg("WhatsApp not enabled"));
            dispatch(setErrorSnack(true));
            return;
        }
        
        const phoneNumber = customer?.mobileNo || "";
        if (!phoneNumber) {
            dispatch(setSnackMsg("No customer mobile number"));
            dispatch(setErrorSnack(true));
            return;
        }

        if (!upiData.upiId) {
            dispatch(setSnackMsg("UPI ID not configured for this payment type"));
            dispatch(setErrorSnack(true));
            return;
        }

        const orderId = orderIdForPos || singleOrderInfo?._id;
        const ordName = singleOrderInfo?.name || '';

        try {
            dispatch(setSnackMsg("Sending payment link..."));
            
            // Send payment link only (not PDF) - customer can click to open UPI app
            const response = await axios.post("pos/sendPaymentLinkWhatsApp", {
                orderId: orderId,
                ordName: ordName,
                customerMobile: phoneNumber,
                paymentAmount: upiData.paidAmt || singleOrderInfo?.amtTotal || 0,
                upiId: upiData.upiId,
                bankingName: upiData.bankingName,
                upiProvider: upiData.upiProvider || 'gpay', // gpay, paytm, phonepe, bhim, other
            }, HEADERS);

            if (response.data?.success) {
                dispatch(setSnackMsg("Payment link sent via WhatsApp"));
                dispatch(setSuccessSnack(true));
            } else {
                dispatch(setSnackMsg(response.data?.message || "Failed to send WhatsApp message"));
                dispatch(setErrorSnack(true));
            }
        } catch (err) {
            console.error("WhatsApp payment link send failed", err);
            dispatch(setSnackMsg("Failed to send payment link"));
            dispatch(setErrorSnack(true));
        }
    };

    // POS Machine payment handler
    const handlePosMachinePayment = async (paymentData) => {
        const providerName = paymentData.posMachineProvider === 'pinelab' ? 'Pine Labs' : 
                            paymentData.posMachineProvider === 'paytm' ? 'Paytm' : 'POS Machine';
        
        // Show processing dialog
        Swal.fire({
            title: `${providerName} Payment`,
            html: `
                <div style="text-align: center; padding: 20px;">
                    <p><strong>Amount:</strong> ₹${paymentData.paidAmt}</p>
                    <p><strong>Provider:</strong> ${providerName}</p>
                    <hr style="margin: 15px 0;">
                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem; margin: 20px 0;">
                        <span class="sr-only">Processing...</span>
                    </div>
                    <p style="color: #666; font-size: 14px;">
                        Initiating payment on ${providerName} POS terminal...
                    </p>
                    <p style="color: #999; font-size: 12px;">
                        Please complete the payment on the POS machine
                    </p>
                </div>
            `,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            allowOutsideClick: false
        });

        try {
            // Call backend API to initiate POS machine payment
            const response = await axios.post('/api/pos-machine/initiate-payment', {
                amount: paymentData.paidAmt,
                orderId: orderIdForPos || singleOrderInfo?._id,
                customerMobile: customer?.mobileNo || '',
                journalId: paymentData.journalId,
                branchId: branchConfigurationList?.branchId
            });

            if (response.data.success) {
                const { transactionId, referenceNumber, status } = response.data.data;
                
                // Payment successful
                Swal.fire({
                    icon: 'success',
                    title: 'Payment Successful!',
                    html: `
                        <div style="text-align: left; padding: 20px;">
                            <p><strong>Amount:</strong> ₹${paymentData.paidAmt}</p>
                            <p><strong>Provider:</strong> ${providerName}</p>
                            <p><strong>Transaction ID:</strong> ${transactionId}</p>
                            <p><strong>Reference:</strong> ${referenceNumber}</p>
                            <p><strong>Status:</strong> ${status}</p>
                        </div>
                    `,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#4CAF50'
                });

                dispatch(setSnackMsg(`${providerName} payment successful - Ref: ${referenceNumber}`));
                dispatch(setErrorSnack(false));

                // Store transaction details in payment data
                // You can update the paymentSelectedArray here if needed
                console.log('✅ POS payment successful:', response.data);

            } else {
                // Payment failed
                Swal.fire({
                    icon: 'error',
                    title: 'Payment Failed',
                    html: `
                        <div style="text-align: left; padding: 20px;">
                            <p style="color: #d32f2f;">${response.data.message || 'Payment was declined'}</p>
                            <hr style="margin: 15px 0;">
                            <p style="font-size: 14px;">Please try again or use a different payment method.</p>
                        </div>
                    `,
                    confirmButtonText: 'Try Again',
                    showCancelButton: true,
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#4CAF50'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Retry payment
                        handlePosMachinePayment(paymentData);
                    }
                });

                dispatch(setSnackMsg(response.data.message || 'Payment failed'));
                dispatch(setErrorSnack(true));
            }

        } catch (error) {
            console.error('❌ POS payment error:', error);
            
            // Show error dialog
            Swal.fire({
                icon: 'error',
                title: 'Payment Error',
                html: `
                    <div style="text-align: left; padding: 20px;">
                        <p style="color: #d32f2f;">${error.response?.data?.message || error.message || 'Failed to initiate payment'}</p>
                        <hr style="margin: 15px 0;">
                        <p style="font-size: 14px;">
                            ${error.response?.data?.message?.includes('configuration') 
                                ? 'Please configure POS machine API credentials in Branch Settings.'
                                : 'Please check your connection and try again.'}
                        </p>
                    </div>
                `,
                confirmButtonText: 'OK',
                confirmButtonColor: '#d32f2f'
            });

            dispatch(setSnackMsg('POS payment failed'));
            dispatch(setErrorSnack(true));
        }
    };

    const finalPlaceOrder = () => {
        const paymentMethodBody = paymentSelectedArray?.map((item) => (
            {
                type: item?.type,
                journalId: item?.journalId || null,
                paidAmt: Number(item?.paidAmt),
                cardId: (cardManual !== undefined && item?.type === "card") ? (item?._id || null) : null,
                approvalCode: item?.approvalCode === "" ? undefined : item?.approvalCode,
                // Include UPI/POS info for WhatsApp payment link
                upiId: item?.upiId || null,
                bankingName: item?.bankingName || null,
                posMachineEnabled: item?.posMachineEnabled || false,
                posMachineProvider: item?.posMachineProvider || null
            }
        ))
        let payload = {
            // Fallback to loaded order if Redux orderIdForPos is not set yet
            orderId: orderIdForPos || singleOrderInfo?._id,
            branchId: userInfo?.branchPk,
            discountAmt: (paymentForm?.discount === "" || paymentForm?.discount === null || paymentForm?.discount === "NaN")
                ? 0 : Number(paymentForm?.discount),
            deliveryCharge: (paymentForm?.deliveryCharge === "" || paymentForm?.deliveryCharge === null || paymentForm?.deliveryCharge === "NaN")
                ? 0 : Number(paymentForm?.deliveryCharge),
            pkgCharge: (paymentForm?.pkgCharge === "" || paymentForm?.pkgCharge === null || paymentForm?.pkgCharge === "NaN")
                ? 0 : Number(paymentForm?.pkgCharge),
            amtTotal: paymentForm?.amountTotal === "" ? 0 : Number(paymentForm?.amountTotal?.toFixed(decimalPosition)),
            paymentDate: `${today} ${getCurrentTime()}`,
            paymentMethod: paymentMethodBody,
            cusId: customer?._id || defaultCustomer?._id,
            ordDuration: getTimeDifference(singleOrderInfo?.orderDate),
            password: authPassWord,
            customerMobile: customer?.mobileNo || null,
            customerName: customer?.name || 'Guest',
            roundOff: roundOff ? paymentForm.roundOffValue : 0,
            // Promo code info for tracking
            promoCode: appliedPromo?.offer?.code || null,
            promoName: appliedPromo?.offer?.name || null,
            promoType: appliedPromo?.offer?.type || null,
            promoApplied: appliedPromo ? true : false,
            // Free delivery info
            freeDeliveryApplied: appliedPromo?.isFreeDelivery || false,
            freeDeliveryKm: appliedPromo?.isFreeDelivery ? (appliedPromo?.deliveryKm || selfDeliveryKm || 0) : 0,
            freeDeliverySaved: appliedPromo?.isFreeDelivery ? (appliedPromo?.discountAmount || 0) : 0
        }

        const sendKotPdfToWhatsApp = async () => {
            // console.log("sendKotPdfToWhatsApp called");
            // WhatsApp billing / payment notifications are now handled centrally in the backend.
            // Disable old frontend PDF send to /sendToWs/send-message.
            return;
        };

        let clearFn = () => {
            dispatch(setDialogBox(null))
            dispatch(setCustomerWallet(null))
            // Reset delivery KM after payment completion
            dispatch(setSelfDeliveryKm(0))
            dispatch(setSelfDeliveryCharge(0))
            sendKotPdfToWhatsApp()
            // Record promo code redemption if applied
            if (appliedPromo?.offer?._id) {
                recordPromoRedemption(orderIdForPos || singleOrderInfo?._id)
                setAppliedPromo(null)
                setPromoCode('')
            }
        }

        if ((branchConfigurationList?.addDiscountAuth && payload?.discountAmt > 0) && !(dialogOpen === "discountAuthPassword")) {
            dispatch(setDialogBox("discountAuthPassword"))
        } else {
            console.log(payload, "finalPaymentPOSApiCallpayload")
            finalPaymentPOSApiCall(payload, clearFn, clearPaymetArrayFunction, handlePaymentSuccess, handlePaymentDeclined)
        }
    }


    const finalPlaceOrderValidations = () => {

        let changeAmt = Number(paymentForm.change)
        // console.log(changeAmt, "changeAmt")
        if (orderIdForPos === null) {
            dispatch(setSnackMsg("Order Not Found !!"))
            dispatch(setErrorSnack(true))
        } else if (shiftStatus === null) {
            dispatch(setSnackMsg("Shift status not available !!"))
            dispatch(setErrorSnack(true))
        } else if (Number(paymentForm.balance) > 0) {
            if (customer === null) {
                dispatch(setSnackMsg("Credit not available !!"))
                dispatch(setErrorSnack(true))
            } else {
                Swal.fire({
                    text: "Balance amount will be added to customer credit!!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#f80000',
                    confirmButtonText: 'Pay',
                    customClass: {
                        cancelButton: 'sweet-alert-cancel-button',
                        confirmButton: 'sweet-alert-submit-button',
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        finalPlaceOrder()
                    }
                })
            }
        } else if (paymentSelectedArray.length === 0) {
            dispatch(setSnackMsg("Payment Method Not Selected !!"))
            dispatch(setErrorSnack(true))
        }
        else if (changeAmt > 0) {
            if (customer !== null && walletStatus) {
                setPaymentForm({ ...paymentForm, changeInWallet: paymentForm.change, wallet: "" })
                dispatch(setDialogBox("walletChange"))
            } else {
                const cashObj = paymentSelectedArray.find(obj => obj.type === "cash");

                if (cashObj) {
                    const modifiedCashObj = { ...cashObj, type: "change", paidAmt: -(changeAmt), change: true };
                    // Add the modified object back to the array
                    paymentSelectedArray.push(modifiedCashObj);
                    finalPlaceOrder()
                }
                else {
                    dispatch(setSnackMsg("Change not cleared !!"))
                    dispatch(setErrorSnack(true))
                }
            }
        }
        else {
            finalPlaceOrder()
        }
    }



    // console.log(paymentSelectedArray,"paymentSelectedArray")
    const payFromWallet = () => {

        let changeAmt = Number(paymentForm.changeInWallet)
        let wallet = Number(paymentForm.wallet)
        const cashObj = paymentSelectedArray.find(obj => obj.type === "cash");

        if (changeAmt > 0) {

            if (cashObj) {
                const modifiedCashObj = { ...cashObj, type: "change", paidAmt: -(changeAmt), change: true };
                paymentSelectedArray.push(modifiedCashObj);
            }
            else {
                dispatch(setSnackMsg("Change not cleared !!"))
            }
        }

        if (wallet > 0) {

            const walletObj = {
                type: "wallet",
                journalId: activeWalletJournel,
                paidAmt: -(wallet),
                cardId: null,
                change: true
            }

            paymentSelectedArray.push(walletObj);

        }

        if (changeAmt > 0 && cashObj === undefined) {
            dispatch(setSnackMsg("Change can only be cleared in cash payment !!"))
            dispatch(setErrorSnack(true))
            walletCancelPopuo()
        } else if (activeWalletJournel === undefined || activeWalletJournel === null) {
            dispatch(setSnackMsg("Wallet journal can't found!!"))
            dispatch(setErrorSnack(true))
            walletCancelPopuo()
        } else {
            finalPlaceOrder()
        }
    }
    // console.log(paymentSelectedArray,"paymentSelectedArray")
    const walletCancelPopuo = () => {
        let walletRemovedArray = paymentSelectedArray.filter(
            (item) => !(item?.type === "wallet"))
        setPaymentSelectedArray(walletRemovedArray)
        dispatch(setDialogBox(null))
    }
    const refundOrderPayment = () => {
        const paymentMethodBody = paymentSelectedArray?.map((item) => (
            {
                type: item?.type,
                journalId: item?.journalId || null,
                paidAmt: -(Number(item?.paidAmt)),
                cardId: (cardManual !== undefined && item?.type === "card") ? (item?._id || null) : null,
                approvalCode: item?.approvalCode === "" ? undefined : item?.approvalCode
            }
        ))
        let refundPayload = {
            mainOrdId: singleOrderInfo?.mainOrdId,
            branchId: singleOrderInfo?.branchId,
            orderInfo: singleOrderInfo?.orderInfo,
            cusId: singleOrderInfo?.cusId,
            subTotal: -Number(singleOrderInfo?.subTotal?.toFixed(decimalPosition)),
            discountAmt: Number(paymentForm.discount),
            totalExclusive: -Number(paymentForm?.totalExcl?.toFixed(decimalPosition)),
            totalInclusive: Number(paymentForm?.totalIncl?.toFixed(decimalPosition)),
            amtTotal: -Number(paymentForm?.amountTotal?.toFixed(decimalPosition)),
            paymentDate: `${today} ${getCurrentTime()}`,
            paymentMethod: paymentMethodBody,
            roundOff: roundOff ? paymentForm.roundOffValue : 0
        }
        let refundUpdatePayload = {
            orderId: singleOrderInfo?.mainOrdId,
            branchId: singleOrderInfo?.branchId,
            paymentDate: `${today} ${getCurrentTime()}`,
            paymentMethod: paymentMethodBody
        }
        if (orderIdForPos === null) {
            dispatch(setSnackMsg("Order Not Found !!"))
            dispatch(setErrorSnack(true))
        } else if (shiftStatus === null) {
            dispatch(setSnackMsg("Shift status not available !!"))
            dispatch(setErrorSnack(true))
        } else if (Number(paymentForm.balance) > 0) {
            dispatch(setSnackMsg("balance amount pending !!"))
            dispatch(setErrorSnack(true))
        } else if (paymentSelectedArray.length === 0) {
            dispatch(setSnackMsg("Payment Method Not Selected !!"))
            dispatch(setErrorSnack(true))
        }
        else {
            let clearFn = () => {
                listOrdersForBillingAPI({ branchId, type: 2 })
            }
            if (singleOrderInfo?.status === "RETURN") {
                refundUpdatePaymentApiCall(refundUpdatePayload, clearFn)
            } else {
                refundPaymentApiCall(refundPayload, clearFn)
            }
        }
    }

    ////////////////////////////////////////correct way////////////////////////////
    // const handleMouseLeave = () => {

    //     const deliveryChargeAmt = typeof paymentForm?.deliveryCharge === 'number' ? paymentForm?.deliveryCharge : parseFloat(paymentForm?.deliveryCharge);
    //     const pkgChargeAmt = typeof paymentForm?.pkgCharge === 'number' ? paymentForm?.pkgCharge : parseFloat(paymentForm?.pkgCharge);
    //     const discountAmount = typeof paymentForm?.discount === 'number' ? paymentForm?.discount : parseFloat(paymentForm?.discount);


    //     setPaymentForm({
    //         ...paymentForm,
    //         deliveryCharge: deliveryChargeAmt?.toFixed(decimalPosition),
    //         pkgCharge: pkgChargeAmt?.toFixed(decimalPosition),
    //         discount: discountAmount?.toFixed(decimalPosition)
    //     })
    // }
    ////////////////////////////////////////////////////////////////////////////////////

    // Example: In handleMouseLeave
    const handleMouseLeave = () => {
        const deliveryChargeAmt = typeof paymentForm?.deliveryCharge === 'number' ? paymentForm?.deliveryCharge : parseFloat(paymentForm?.deliveryCharge);
        const pkgChargeAmt = typeof paymentForm?.pkgCharge === 'number' ? paymentForm?.pkgCharge : parseFloat(paymentForm?.pkgCharge);
        const discountAmount = typeof paymentForm?.discount === 'number' ? paymentForm?.discount : parseFloat(paymentForm?.discount);

        // console.log("deliveryChargeAmt before toFixed:", deliveryChargeAmt);
        const deliveryChargeFixed = deliveryChargeAmt?.toFixed(decimalPosition);
        // console.log("deliveryChargeAmt after toFixed:", deliveryChargeFixed);

        // console.log("pkgChargeAmt before toFixed:", pkgChargeAmt);
        const pkgChargeFixed = pkgChargeAmt?.toFixed(decimalPosition);
        // console.log("pkgChargeAmt after toFixed:", pkgChargeFixed);

        // console.log("discountAmount before toFixed:", discountAmount);
        const discountFixed = discountAmount?.toFixed(decimalPosition);
        // console.log("discountAmount after toFixed:", discountFixed);

        setPaymentForm({
            ...paymentForm,
            deliveryCharge: deliveryChargeFixed,
            pkgCharge: pkgChargeFixed,
            discount: discountFixed
        })
    }


    const paymentRowClick = (index) => () => {
        setSelectedPaymentRow(index === selectedPaymentRow ? null : index)
        dispatch(setInputCalculator(""))
    }
    ////////////////////////////correct/////////////////////////////
    // const handleMouseLeavePayment = () => {

    //     let roundedArray = paymentSelectedArray.map((item) => {
    //         const paidAmtNumber = typeof item.paidAmt === 'number' ? item.paidAmt : parseFloat(item.paidAmt);
    //         return {
    //             ...item,
    //             paidAmt: paidAmtNumber.toFixed(decimalPosition),
    //         };
    //     }
    //     )
    //     // setInitialRefresh(true)
    //     setPaymentSelectedArray(roundedArray)
    // }
    /////////////////////////////////////////////////////////////////////

    // Example: In handleMouseLeavePayment
    const handleMouseLeavePayment = () => {
        let roundedArray = paymentSelectedArray.map((item) => {
            const paidAmtNumber = typeof item.paidAmt === 'number' ? item.paidAmt : parseFloat(item.paidAmt);
            // console.log("paidAmt before toFixed:", paidAmtNumber);
            const paidAmtFixed = paidAmtNumber.toFixed(decimalPosition);
            // console.log("paidAmt after toFixed:", paidAmtFixed);
            return {
                ...item,
                paidAmt: paidAmtFixed,
            };
        });
        setPaymentSelectedArray(roundedArray)
    }


    const handleClickQr = (row) => {
        setCustomerDisplayQRInfo((prevState) =>
        ({
            ...prevState,
            open: true,
            bankAccount: row?.upiId,
            payeeName: row?.bankingName,
            amount: row?.paidAmt,
            currency: currencyDetails?.symbol || 'AED',
            status: 'pending' // Reset to pending when QR is shown
        }))
    }

    // Update customer display QR status for payment success
    const handlePaymentSuccess = () => {
        console.log('💳 Payment Success - updating customer display');
        
        // Calculate total paid amount from payment array
        const totalPaid = paymentSelectedArray.reduce((sum, item) => {
            if (item.change !== true) {
                return sum + Number(item.paidAmt || 0);
            }
            return sum;
        }, 0);
        
        // Get the amount to display - use total paid, or fall back to order total
        const displayAmount = totalPaid || paymentForm?.amountTotal || paymentForm?.totalAmt || singleOrderInfo?.amtTotal || 0;
        
        console.log('💳 Payment Success - amount:', displayAmount);
        
        // Set success status with clearCart flag
        setCustomerDisplayQRInfo({
            open: true,
            label: 'Payment Successful',
            bankAccount: '',
            payeeName: '',
            amount: displayAmount,
            currency: currencyDetails?.symbol || 'AED',
            status: 'success',
            clearCart: true // Flag to clear cart on customer display
        });
        
        // Reset QR info after 3.5 seconds to prevent it from showing on next order
        setTimeout(() => {
            setCustomerDisplayQRInfo({
                open: false,
                label: '',
                bankAccount: '',
                payeeName: '',
                amount: '',
                currency: currencyDetails?.symbol || 'AED',
                status: 'pending'
            });
        }, 3500);
    }

    // Update customer display QR status for payment declined
    const handlePaymentDeclined = () => {
        setCustomerDisplayQRInfo((prevState) => ({
            ...prevState,
            status: 'declined'
        }));
    }

    // Promo Code Functions - Offline/Online Compatible
    
    // Cache offers locally for offline validation
    const OFFERS_CACHE_KEY = 'pos_cached_offers'
    const PENDING_REDEMPTIONS_KEY = 'pos_pending_promo_redemptions'
    
    const getCachedOffers = () => {
        try {
            const cached = localStorage.getItem(OFFERS_CACHE_KEY)
            if (cached) {
                const { offers, timestamp } = JSON.parse(cached)
                // Cache valid for 24 hours
                if (Date.now() - timestamp < 24 * 60 * 60 * 1000) {
                    return offers
                }
            }
        } catch (e) {}
        return []
    }
    
    const cacheOffers = (offers) => {
        try {
            localStorage.setItem(OFFERS_CACHE_KEY, JSON.stringify({
                offers,
                timestamp: Date.now()
            }))
        } catch (e) {}
    }
    
    // Validate offer offline using cached data
    const validateOfferOffline = (code, orderValue) => {
        const cachedOffers = getCachedOffers()
        const offer = cachedOffers.find(o => 
            o.code?.toUpperCase() === code.toUpperCase() && 
            o.isActive &&
            new Date(o.startDate) <= new Date() &&
            new Date(o.endDate) >= new Date()
        )
        
        if (!offer) return { valid: false, message: 'Invalid or expired promo code' }
        
        if (offer.minOrderValue && orderValue < offer.minOrderValue) {
            return { valid: false, message: `Minimum order value: ${currencyDetails?.symbol || '₹'}${offer.minOrderValue}` }
        }
        
        let discountAmount = 0
        if (offer.type === 'PERCENTAGE') {
            discountAmount = (orderValue * offer.value) / 100
            if (offer.maxDiscount && discountAmount > offer.maxDiscount) {
                discountAmount = offer.maxDiscount
            }
        } else if (offer.type === 'FIXED_AMOUNT') {
            discountAmount = offer.value
        } else if (offer.type === 'FREE_DELIVERY') {
            discountAmount = Number(paymentForm?.deliveryCharge || 0)
        }
        
        return {
            valid: true,
            offer,
            discountAmount,
            message: offer.type === 'PERCENTAGE' ? `${offer.value}% off applied!` : `${currencyDetails?.symbol || '₹'}${discountAmount} off!`,
            isOffline: true
        }
    }
    
    // Queue redemption for later sync when offline
    const queueRedemptionForSync = (redemptionData) => {
        try {
            const pending = JSON.parse(localStorage.getItem(PENDING_REDEMPTIONS_KEY) || '[]')
            pending.push({
                ...redemptionData,
                queuedAt: new Date().toISOString()
            })
            localStorage.setItem(PENDING_REDEMPTIONS_KEY, JSON.stringify(pending))
            console.log('📦 Promo redemption queued for sync')
        } catch (e) {
            console.error('Failed to queue redemption:', e)
        }
    }

    const handleApplyPromoCode = async () => {
        if (!promoCode.trim()) {
            dispatch(setSnackMsg("Please enter a promo code"))
            dispatch(setErrorSnack(true))
            return
        }

        setPromoLoading(true)
        const orderValue = Number(singleOrderInfo?.totalExclusive || 0) + Number(singleOrderInfo?.subTotal || 0)
        
        try {
            // Try online validation first
            const res = await axios.post('api/crm/offers/validate', {
                code: promoCode.trim().toUpperCase(),
                customerId: customer?._id || null,
                orderValue: orderValue
            }, HEADERS)

            console.log('🎫 Promo validation response:', res.status, res.data)

            // Check for successful validation
            // API returns: { data: { valid: true, offer, discountAmount, message }, status: 200 }
            // Or wrapped: { data: { data: {...}, status: 200 }, status: 200 }
            const responseData = res.data?.data?.valid !== undefined ? res.data.data : res.data
            
            if (res.status === 200 && responseData?.valid === true) {
                const { offer, discountAmount, message } = res.data.data
                
                // Check if FREE_DELIVERY promo is only applied on DELIVERY orders
                if (offer?.type === 'FREE_DELIVERY' && billType !== 'DELIVERY') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Delivery Orders Only',
                        text: 'This promo code is only valid for delivery orders. Please select DELIVERY as order type.',
                        confirmButtonColor: '#ff9800'
                    })
                    setPromoLoading(false)
                    return
                }
                
                // For FREE_DELIVERY, calculate the actual delivery charge saved
                let actualDiscountAmount = discountAmount
                let savedMessage = message
                if (offer?.type === 'FREE_DELIVERY') {
                    actualDiscountAmount = selfDeliveryCharge || 0
                    savedMessage = selfDeliveryKm > 0 
                        ? `Free Delivery for ${selfDeliveryKm} KM!` 
                        : 'Free Delivery Applied!'
                }
                
                setAppliedPromo({ 
                    offer, 
                    discountAmount: actualDiscountAmount, 
                    message: savedMessage, 
                    isOffline: false,
                    isFreeDelivery: offer?.type === 'FREE_DELIVERY',
                    deliveryKm: selfDeliveryKm || 0
                })
                
                // Cache this offer for future offline use
                const cachedOffers = getCachedOffers()
                if (!cachedOffers.find(o => o._id === offer._id)) {
                    cacheOffers([...cachedOffers, offer])
                }
                
                // Apply discount to payment form (for FREE_DELIVERY, set delivery charge to 0)
                if (offer?.type === 'FREE_DELIVERY') {
                    // Don't add to discount, delivery charge will be set to 0 in calculation
                    paymentFormOnChange("discount", "0")
                } else {
                    paymentFormOnChange("discount", actualDiscountAmount.toString())
                }
                
                // Show appropriate success message
                const saveText = offer?.type === 'FREE_DELIVERY' 
                    ? (selfDeliveryKm > 0 ? `Free Delivery: ${selfDeliveryKm} KM (${currencyDetails?.symbol || '₹'}${actualDiscountAmount.toFixed(2)})` : `Free Delivery: ${currencyDetails?.symbol || '₹'}${actualDiscountAmount.toFixed(2)}`)
                    : `You save: ${currencyDetails?.symbol || '₹'}${actualDiscountAmount.toFixed(2)}`
                
                Swal.fire({
                    icon: 'success',
                    title: 'Promo Applied!',
                    html: `<div style="text-align: center;">
                        <p style="font-size: 24px; color: #4CAF50; font-weight: bold;">${savedMessage}</p>
                        <p style="font-size: 18px;">${saveText}</p>
                    </div>`,
                    timer: 2000,
                    showConfirmButton: false
                })
            } else {
                // Handle error response - data could be string or object
                // API returns status: 0 for errors with message in data field
                let errorMsg = 'This promo code is not valid'
                if (typeof res.data?.data === 'string') {
                    errorMsg = res.data.data
                } else if (res.data?.data?.message) {
                    errorMsg = res.data.data.message
                } else if (typeof res.data === 'string') {
                    errorMsg = res.data
                }
                console.log('🎫 Promo validation failed:', errorMsg)
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Code',
                    text: errorMsg,
                    confirmButtonColor: '#d33'
                })
            }
        } catch (error) {
            // Check if it's an HTTP error response (400, 404, etc.)
            if (error.response && error.response.data) {
                const errorData = error.response.data.data
                const errorMsg = typeof errorData === 'string' ? errorData : 'This promo code is not valid'
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Code',
                    text: errorMsg,
                    confirmButtonColor: '#d33'
                })
            } else {
                // Network error - try offline validation
                console.log('🔌 Network error, trying offline validation...')
                
                const offlineResult = validateOfferOffline(promoCode.trim().toUpperCase(), orderValue)
                
                if (offlineResult.valid) {
                    setAppliedPromo({
                        offer: offlineResult.offer,
                        discountAmount: offlineResult.discountAmount,
                        message: offlineResult.message,
                        isOffline: true
                    })
                    
                    paymentFormOnChange("discount", offlineResult.discountAmount.toString())
                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Promo Applied (Offline)',
                        html: `<div style="text-align: center;">
                            <p style="font-size: 24px; color: #4CAF50; font-weight: bold;">${offlineResult.message}</p>
                            <p style="font-size: 18px;">You save: ${currencyDetails?.symbol || '₹'}${offlineResult.discountAmount.toFixed(2)}</p>
                            <p style="font-size: 12px; color: #ff9800;">⚠️ Validated offline - will sync when online</p>
                        </div>`,
                        timer: 3000,
                        showConfirmButton: false
                    })
                } else {
                    // No cached offers or invalid code
                    Swal.fire({
                        icon: 'warning',
                        title: 'Cannot Validate',
                        text: navigator.onLine ? offlineResult.message : 'Network unavailable. Promo codes require internet connection for first-time validation.',
                        confirmButtonColor: '#f57c00'
                    })
                }
            }
        } finally {
            setPromoLoading(false)
        }
    }

    const handleRemovePromoCode = () => {
        setAppliedPromo(null)
        setPromoCode('')
        paymentFormOnChange("discount", "0")
        dispatch(setSnackMsg("Promo code removed"))
        dispatch(setErrorSnack(false))
    }

    // Record promo redemption after successful payment - handles offline
    const recordPromoRedemption = async (orderId) => {
        if (!appliedPromo?.offer?._id) return
        
        const redemptionData = {
            offerId: appliedPromo.offer._id,
            customerId: customer?._id || null,
            orderId: orderId,
            discountAmount: appliedPromo.discountAmount,
            code: appliedPromo.offer.code
        }
        
        try {
            const res = await axios.post(`api/crm/offers/${appliedPromo.offer._id}/redeem`, {
                customerId: customer?._id || null,
                orderId: orderId,
                discountAmount: appliedPromo.discountAmount
            }, HEADERS)
            
            // Handle both online (200) and offline queued (202)
            if (res.status === 200 || res.status === 202) {
                console.log(`✅ Promo redemption ${res.status === 202 ? 'queued (offline)' : 'recorded'}`)
            }
        } catch (error) {
            // Network error - queue for later sync
            console.log('🔌 Network error, queuing redemption for sync...')
            queueRedemptionForSync(redemptionData)
        }
    }
    
    // Sync pending redemptions when online (call this on app init or network restore)
    const syncPendingRedemptions = async () => {
        try {
            const pending = JSON.parse(localStorage.getItem(PENDING_REDEMPTIONS_KEY) || '[]')
            if (pending.length === 0) return
            
            const synced = []
            for (const redemption of pending) {
                try {
                    await axios.post(`api/crm/offers/${redemption.offerId}/redeem`, {
                        customerId: redemption.customerId,
                        orderId: redemption.orderId,
                        discountAmount: redemption.discountAmount
                    }, HEADERS)
                    synced.push(redemption)
                } catch (e) {
                    // Keep failed ones for next sync
                }
            }
            
            // Remove synced items
            const remaining = pending.filter(p => !synced.includes(p))
            localStorage.setItem(PENDING_REDEMPTIONS_KEY, JSON.stringify(remaining))
            
            if (synced.length > 0) {
                console.log(`✅ Synced ${synced.length} pending promo redemptions`)
            }
        } catch (e) {}
    }
    
    // Pre-fetch and cache active offers for offline use
    const prefetchOffersForOffline = async () => {
        try {
            const res = await axios.get('api/crm/offers', HEADERS)
            if (res.status === 200 && res.data?.data) {
                // Only cache active offers
                const activeOffers = res.data.data.filter(o => 
                    o.isActive && 
                    new Date(o.endDate) >= new Date() &&
                    new Date(o.startDate) <= new Date()
                )
                cacheOffers(activeOffers)
                console.log(`📦 Cached ${activeOffers.length} active offers for offline use`)
            }
        } catch (e) {
            console.log('Could not prefetch offers (offline or error)')
        }
    }
    
    // Try to sync pending redemptions and prefetch offers when component mounts and online
    useEffect(() => {
        if (navigator.onLine) {
            syncPendingRedemptions()
            prefetchOffersForOffline()
        }
        
        const handleOnline = () => {
            syncPendingRedemptions()
            prefetchOffersForOffline()
        }
        window.addEventListener('online', handleOnline)
        return () => window.removeEventListener('online', handleOnline)
    }, [])
    useEffect(() => {
        if (posSettings?.posStatus) {
            setPaymentsTypeArray(paymentTypesForBranch)
        } else {
            let paymentArray = [
                {
                    journalName: "Cash",
                    type: "cash"
                },
                {
                    journalName: "Card",
                    type: "card"
                },
                {
                    journalName: "Cheque",
                    type: "cheque"
                },
            ]
            setPaymentsTypeArray(paymentArray)
        }
    }, [paymentTypesForBranch, posSettings])

    // to ge the sum of selected payment methods input
    useEffect(() => {
        if (!(paymentSelectedArray.some(obj => obj.type === "wallet"))) {
            setCusWalletObj({ ...cusWalletObj, walletBalance: customerWallet?.walletBalance || 0 })
        }
        if (paymentSelectedArray.length === 0 && initialRefresh === false) {
            setPaymentForm({ ...paymentForm, paidAmount: 0 })
            setCusWalletObj({ ...cusWalletObj, walletBalance: customerWallet?.walletBalance || 0 })
        } else {
            let total = paymentSelectedArray?.reduce((sum, item) => sum + Number(item?.paidAmt), 0)
            setPaymentForm({ ...paymentForm, paidAmount: total })
        }
    }, [paymentSelectedArray])
console.log(paymentSelectedArray);

    useEffect(() => {
        initialRefresh === false && calculateCHangeAndBal()
        // setInitialRefresh(false)

    }, [paymentForm.paidAmount, paymentForm.amountTotal]);


    useEffect(() => {
        if (singleOrderInfo !== null) {
            const itemsTotal = Number(singleOrderInfo?.totalExclusive || 0) + Number(singleOrderInfo?.subTotal || 0);
            // Use promo discount if applied, otherwise use order's existing discount
            let discountNum = Number(singleOrderInfo?.discountAmt || 0);
            if (appliedPromo && !appliedPromo.isFreeDelivery) {
                discountNum = Number(appliedPromo.discountAmount || 0);
                console.log('🎫 Using promo discount:', discountNum);
            }
            const baseAmount = itemsTotal; // base = items without delivery/pkg

            // Compute default delivery charge
            const deliveryEnabled = !!branchSettingsView?.deliveryCharge;
            const freeAbove = Number(branchSettingsView?.freeDeliveryAbove || 0);
            const flat = Number(branchSettingsView?.deliveryAmt || 0);
            const mode = branchSettingsView?.deliveryChargeMode || 'flat';
            const perKm = Number(branchSettingsView?.perKmCharge || 0);
            const rules = Array.isArray(branchSettingsView?.kmRangeRules) ? branchSettingsView.kmRangeRules : [];
            const isDeliveryOrder = (billType === 'DELIVERY' || singleOrderInfo?.ordType === 'DELIVERY');
            const amountForFreeCheck = Math.max(0, baseAmount - discountNum);

            console.log('🚚 DELIVERY CHARGE DEBUG:', {
                mode,
                deliveryEnabled,
                isDeliveryOrder,
                aggregator,
                selfDeliveryKm,
                flat,
                perKm,
                rules,
                ordStatus: singleOrderInfo?.ordStatus,
                isPaid: singleOrderInfo?.isPaid,
                existingCharge: singleOrderInfo?.deliveryCharge,
                existingAmt: singleOrderInfo?.deliveryAmt
            });

            // Respect existing delivery charge from order if it exists
            // This ensures that orders created with per_km/km_range charges maintain their original charge
            const existingDeliveryFromOrder = Number(singleOrderInfo?.deliveryCharge ?? singleOrderInfo?.deliveryAmt ?? 0) || 0;
            let computedDelivery = existingDeliveryFromOrder;
            
            console.log('🔍 ORDER STATUS CHECK:', {
                ordStatus: singleOrderInfo?.ordStatus,
                isPaid: singleOrderInfo?.isPaid,
                existingDeliveryFromOrder,
                computedDeliveryInitial: computedDelivery,
                willRecalculate: computedDelivery === 0 && isDeliveryOrder && deliveryEnabled
            });
            
            if (computedDelivery === 0 && isDeliveryOrder && deliveryEnabled) {
                if (freeAbove > 0 && amountForFreeCheck >= freeAbove) {
                    computedDelivery = 0;
                    console.log('✅ Free delivery (above threshold)');
                } else if (aggregator?.isSelf) {
                    console.log('🚗 Self delivery - mode:', mode);
                    // Respect selected mode when self delivery
                    if (mode === 'per_km') {
                        const km = Number(selfDeliveryKm || 0);
                        computedDelivery = Math.max(0, (perKm || 0) * Math.max(0, km));
                        console.log('📏 Per KM:', km, 'x', perKm, '=', computedDelivery);
                    } else if (mode === 'km_range') {
                        const km = Number(selfDeliveryKm || 0);
                        console.log('📍 KM Range mode - km:', km, 'rules:', rules);
                        console.log('🔍 Rules details:', rules.map(r => ({
                            fromKm: r?.fromKm,
                            toKm: r?.toKm,
                            charge: r?.charge,
                            isFree: r?.isFree,
                            matches: Number(r?.fromKm) <= km && km <= Number(r?.toKm)
                        })));
                        const match = rules.find(r => Number(r?.fromKm) <= km && km <= Number(r?.toKm));
                        console.log('🎯 Matched rule:', match);
                        if (match) {
                            computedDelivery = match?.isFree ? 0 : Number(match?.charge || 0);
                            console.log('💰 Range charge:', computedDelivery);
                            setKmRangeError(null); // Clear error when valid range found
                        } else {
                            computedDelivery = 0; // default if no range matched
                            console.log('❌ No range matched, charge = 0');
                            // Set error message with available ranges
                            if (rules.length > 0 && km > 0) {
                                const rangeText = rules.map(r => `${r?.fromKm}-${r?.toKm} km`).join(', ');
                                const errorMsg = `${km} km is outside configured delivery ranges. Available ranges: ${rangeText}`;
                                console.log('🚨 Setting kmRangeError:', errorMsg);
                                setKmRangeError(errorMsg);
                            } else if (km > 0) {
                                const errorMsg = `No delivery ranges configured. Please contact administrator.`;
                                console.log('🚨 Setting kmRangeError:', errorMsg);
                                setKmRangeError(errorMsg);
                            } else {
                                console.log('✅ Clearing kmRangeError (km = 0)');
                                setKmRangeError(null);
                            }
                        }
                    } else {
                        // flat mode
                        computedDelivery = flat || 0;
                        console.log('💵 Flat mode:', computedDelivery);
                        setKmRangeError(null); // Clear error for flat mode
                    }
                } else {
                    // Non-self or missing aggregator falls back to flat
                    computedDelivery = flat || 0;
                    console.log('🏢 Non-self delivery, using flat:', computedDelivery);
                    setKmRangeError(null); // Clear error for non-self
                }
            } else {
                console.log('⏭️ Skipped calculation - computedDelivery:', computedDelivery, 'isDeliveryOrder:', isDeliveryOrder, 'deliveryEnabled:', deliveryEnabled);
                setKmRangeError(null); // Clear error when not calculating
            }
            
            console.log('✅ FINAL computedDelivery:', computedDelivery);

            // Check if FREE_DELIVERY promo is applied - set delivery to 0
            if (appliedPromo?.isFreeDelivery) {
                computedDelivery = 0;
                console.log('🎁 FREE_DELIVERY promo applied - delivery charge set to 0');
            }

            // include delivery and packaging in totals by default
            const pkg = Number(singleOrderInfo?.pkgCharge || 0) || 0;
            const computedDeliveryNum = Number(computedDelivery) || 0;
            const initialAmountTotalRaw = Math.max(0, baseAmount - discountNum) + computedDeliveryNum + pkg;

            let initialAmountTotal = initialAmountTotalRaw;
            let roundOffValue = 0;
            if (roundOff) {
                const rounded = calculateRoundedAmount(initialAmountTotalRaw);
                initialAmountTotal = rounded.roundedAmount;
                roundOffValue = rounded.roundOffValue;
            }
            const initialBalance = initialAmountTotal;

            setInitialRefresh(false)
            setPaymentForm({
                ...paymentForm,
                paidAmount: 0,
                amountTotal: initialAmountTotal,
                totalExcl: Number(singleOrderInfo?.totalExclusive || 0),
                totalIncl: Number(singleOrderInfo?.totalInclusive || 0),
                discount: Number(discountNum).toFixed(decimalPosition),
                change: 0,
                balance: initialBalance,
                amountPaid: (itemsTotal - Number(singleOrderInfo?.amountDue || 0))?.toFixed(decimalPosition),
                deliveryCharge: computedDeliveryNum.toFixed(decimalPosition),
                pkgCharge: pkg.toFixed(decimalPosition),
                orderAmount: Number(baseAmount).toFixed(decimalPosition),
                roundOffValue
            })
        }
    }, [singleOrderInfo, billType, aggregator, selfDeliveryKm, branchSettingsView, appliedPromo])
    


    useEffect(() => {
        if (selectedPaymentRow !== null) {

            let amt = inputValueCalculator !== "" ? Number(inputValueCalculator)?.toFixed(decimalPosition) : "0.00"
            let duplicateArray = [...paymentSelectedArray]
            duplicateArray[selectedPaymentRow] = { ...duplicateArray[selectedPaymentRow], paidAmt: amt }

            setPaymentSelectedArray(duplicateArray)
        }
    }, [inputValueCalculator])
    useEffect(() => {
        getDiscountAPICall()

    }, [])


    useEffect(() => {
        if (customerWallet === null) {
            setCusWalletObj(cusWalletObjInitial)
        } else {
            setCusWalletObj({ ...cusWalletObj, walletBalance: customerWallet?.walletBalance })
        }
        setPaymentSelectedArray([])
    }, [customerWallet])
    return (
        <div className='billing-main-container billing-payment'>
            <div className="billing-left-container" style={{ height: "100%", display: "flex", flexDirection: "column" }}>

                <div className="flex-row" style={{ gap: "5px" }}>
                    <div className='justify-center' style={{ backgroundColor: "#fff", width: "40px" }}>
                        <IconButton
                            onClick={() => {
                                dispatch(setBtnSelected(null))
                                dispatch(setOrderIdInPOS(null))
                            }}
                        >
                            <HomeIcon sx={{ color: "green" }} />
                        </IconButton>
                    </div>
                    <TopBar />
                </div>

                <div className="billing-payment-ctn">
                    <div className="billing-payment-ctn-left">
                        <div className="payment-table-div">

                            <table>
                                <thead>
                                    <tr>
                                        <th className='name' style={{ paddingLeft: "25px" }}>Name</th>
                                        <th>&nbsp;</th>
                                        <th>Qty.</th>
                                        <th>Price</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        singleOrderInfo?.orderInfo?.map((r, i) => (
                                            <tr key={i}>
                                                <td style={{ paddingLeft: "25px" }}>{r?.desccription}</td>
                                                <td>&nbsp;</td>
                                                <td>{Math.abs(r?.qty)}</td>
                                                <td>{r?.unitPrice}</td>
                                                <td>{Math.abs(r?.subTotalWoTax)}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                       
                        <div className="bottom">
                            <p>Subtotal</p>
                            <div>{currencyDetails?.symbol} {Math.abs(singleOrderInfo?.subTotal)?.toFixed(decimalPosition) || "---"}</div>
                        </div>
                    </div>
                    <div className="billing-payment-ctn-right">
                        <div className="billing-payment-input-rows"
                        >
                            <div className="billing-input-field">
                                <p>Order Amount</p>
                                <input
                                    placeholder="00.00"
                                    type="number"
                                    value={paymentForm?.orderAmount}
                                    readOnly
                                />
                            </div>
                            {
                                singleOrderInfo?.ordType === "DELIVERY" &&
                                <div className="billing-input-field">
                                    <p>Delivery charge</p>
                                    <input
                                        placeholder="0.00"
                                        type="number"
                                        onFocus={(e) => e.target.select()}
                                        value={paymentForm?.deliveryCharge}
                                        onChange={(e) => paymentFormOnChange("deliveryCharge", e.target.value)}
                                        onBlur={handleMouseLeave}
                                        disabled={singleOrderInfo?.type === "refund" || (branchConfigurationList?.deliveryCharge)}
                                    />
                                </div>}
                            {
                                !(singleOrderInfo?.ordType === "DINEIN") &&
                                <div className="billing-input-field">
                                    <p>Packaging charge</p>
                                    <input
                                        placeholder="0.00"
                                        type="number"
                                        onFocus={(e) => e.target.select()}
                                        value={paymentForm?.pkgCharge}
                                        onChange={(e) => paymentFormOnChange("pkgCharge", e.target.value)}
                                        onBlur={handleMouseLeave}
                                        disabled={singleOrderInfo?.type === "refund" || (branchConfigurationList?.packagingCharge)}
                                    />
                                </div>}
                            {/* <div className="billing-input-field">
                                <p>Discount</p>
                                <input
                                    placeholder="0.00"
                                    type="number"
                                    value={paymentForm?.discount}
                                    onChange={(e) => paymentFormOnChange("discount", e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                    onBlur={handleMouseLeave}
                                    disabled={singleOrderInfo?.type === "refund" || (singleOrderInfo?.status === "DONE" && singleOrderInfo?.amountDue > 0)}
                                />
                            </div> */}
                            {/* % wise */}
                            <div className="billing-input-field discount-field">
                                <p>Discount</p>
                                <div className="input-wrapper">
                                    <input
                                        placeholder="0.00"
                                        type="number"
                                        value={paymentForm?.discount}
                                        onChange={(e) => paymentFormOnChange("discount", e.target.value)}
                                        onFocus={(e) => e.target.select()}
                                        onBlur={handleMouseLeave}
                                        disabled={singleOrderInfo?.type === "refund" ||
                                            (singleOrderInfo?.status === "DONE" && singleOrderInfo?.amountDue > 0)}
                                    />
                                    {paymentForm.isDiscountPercentage && (
                                        <span className="percent-symbol">%</span>
                                    )}
                                </div>


                            </div>
                          {discountData?.showinPos && (
    <p
        style={{ cursor: "pointer", color: "#1976d2", textDecoration: "underline" }}
        onClick={() => {
            if (!singleOrderInfo) return;

            const baseAmount = Number(singleOrderInfo?.totalExclusive || 0) + Number(singleOrderInfo?.subTotal || 0);
            let discountValue = 0;

            if (paymentForm?.isDiscountPercentage) {
                discountValue = Number(discountData?.discountAmount);
            } else {
                discountValue = (baseAmount * Number(discountData?.discountAmount)) / 100;
            }

            paymentFormOnChange("discount", discountValue.toString());
        }}
    >
        Max Discount :{" "}
        {paymentForm?.isDiscountPercentage
            ? `${discountData?.discountAmount}%`
            : `₹${((singleOrderInfo?.totalExclusive + singleOrderInfo?.subTotal) * discountData?.discountAmount / 100).toFixed(2)}`}
    </p>
)}

                            <div className="billing-input-checkbox" style={{ marginTop: '6px' }}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={paymentForm?.isDiscountPercentage}
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;

                                            setPaymentForm((prev) => {
                                                const baseAmount = Number(singleOrderInfo?.totalExclusive || 0) + Number(singleOrderInfo?.subTotal || 0);
                                                const currentDiscount = Number(prev.discount || 0);

                                                let newDiscount = currentDiscount;
                                                let newPercentageDiscountAmount = 0;

                                                if (isChecked) {
                                                    // ₹ → % (Convert amount to percentage)
                                                    if (baseAmount > 0) {
                                                        newDiscount = (currentDiscount / baseAmount) * 100;
                                                        newPercentageDiscountAmount = currentDiscount;
                                                    }
                                                } else {
                                                    // % → ₹ (Convert % to amount)
                                                    newPercentageDiscountAmount = (baseAmount * currentDiscount) / 100;
                                                    newDiscount = newPercentageDiscountAmount;
                                                }

                                                return {
                                                    ...prev,
                                                    isDiscountPercentage: isChecked,
                                                    discount: Number(newDiscount?.toFixed(2)),
                                                    percentageDiscountAmount: Number(newPercentageDiscountAmount?.toFixed(2)),
                                                };
                                            });
                                        }}

                                    />

                                    Apply discount as percentage
                                </label>
                            </div>
                            {paymentForm?.isDiscountPercentage && paymentForm?.percentageDiscountAmount > 0 && (
                                <div>
                                    <span>
                                        Discount Amount: ₹{Number(paymentForm.percentageDiscountAmount).toFixed(2)}
                                    </span>
                                </div>
                            )}

                            {/* Promo Code Section */}
                            <div className="billing-input-field promo-code-section" style={{ marginTop: '12px' }}>
                                <p style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <LocalOfferIcon style={{ fontSize: '16px', color: '#1976d2' }} />
                                    Promo Code
                                </p>
                                {appliedPromo ? (
                                    <div style={{ 
                                        backgroundColor: appliedPromo.isOffline ? '#fff3e0' : '#e8f5e9',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        border: `1px solid ${appliedPromo.isOffline ? '#ff9800' : '#4CAF50'}`
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                            <CheckCircleIcon style={{ color: appliedPromo.isOffline ? '#ff9800' : '#4CAF50', fontSize: '20px' }} />
                                            <span style={{ fontWeight: 'bold', color: appliedPromo.isOffline ? '#e65100' : '#2e7d32', fontSize: '16px', fontFamily: 'monospace' }}>
                                                {appliedPromo.offer?.code}
                                            </span>
                                            {appliedPromo.isOffline && <span style={{ fontSize: '10px', color: '#ff9800', background: '#fff3e0', padding: '2px 6px', borderRadius: '4px' }}>⚡ OFFLINE</span>}
                                            <IconButton 
                                                size="small" 
                                                onClick={handleRemovePromoCode}
                                                style={{ color: '#d32f2f', marginLeft: 'auto' }}
                                            >
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        </div>
                                        <div style={{ fontSize: '13px', color: '#2e7d32', marginBottom: '6px' }}>
                                            ✓ {appliedPromo.message}
                                        </div>
                                        <div style={{ 
                                            display: 'flex', 
                                            justifyContent: 'space-between', 
                                            alignItems: 'center',
                                            backgroundColor: appliedPromo.isFreeDelivery ? '#fff3e0' : '#c8e6c9',
                                            padding: '8px 12px',
                                            borderRadius: '6px',
                                            marginBottom: '8px'
                                        }}>
                                            <span style={{ fontSize: '12px', color: appliedPromo.isFreeDelivery ? '#e65100' : '#1b5e20' }}>
                                                {appliedPromo.isFreeDelivery ? '🚚 Free Delivery' : 'You Save'}
                                            </span>
                                            <span style={{ fontSize: '18px', fontWeight: 'bold', color: appliedPromo.isFreeDelivery ? '#e65100' : '#1b5e20' }}>
                                                {appliedPromo.isFreeDelivery 
                                                    ? (appliedPromo.deliveryKm > 0 
                                                        ? `${appliedPromo.deliveryKm} KM (${currencyDetails?.symbol || '₹'}${appliedPromo.discountAmount?.toFixed(2)})` 
                                                        : `${currencyDetails?.symbol || '₹'}${appliedPromo.discountAmount?.toFixed(2)}`)
                                                    : `${currencyDetails?.symbol || '₹'}${appliedPromo.discountAmount?.toFixed(2)}`
                                                }
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', gap: '12px', fontSize: '11px', color: '#666' }}>
                                            {appliedPromo.offer?.maxUsageTotal && (
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ color: '#1976d2' }}>📊</span>
                                                    Usage: {appliedPromo.offer?.currentUsageCount || 0}/{appliedPromo.offer?.maxUsageTotal}
                                                </span>
                                            )}
                                            {appliedPromo.offer?.endDate && (
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ color: '#f57c00' }}>📅</span>
                                                    Expires: {new Date(appliedPromo.offer.endDate).toLocaleDateString()}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <input
                                            placeholder="Enter promo code"
                                            type="text"
                                            value={promoCode}
                                            onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                                            onKeyPress={(e) => e.key === 'Enter' && handleApplyPromoCode()}
                                            style={{ 
                                                flex: 1,
                                                textTransform: 'uppercase',
                                                fontFamily: 'monospace',
                                                letterSpacing: '1px'
                                            }}
                                            disabled={singleOrderInfo?.type === "refund" || promoLoading}
                                        />
                                        <button
                                            onClick={handleApplyPromoCode}
                                            disabled={promoLoading || !promoCode.trim()}
                                            style={{
                                                padding: '8px 16px',
                                                backgroundColor: promoLoading ? '#ccc' : '#1976d2',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: promoLoading ? 'not-allowed' : 'pointer',
                                                fontWeight: 'bold',
                                                minWidth: '80px'
                                            }}
                                        >
                                            {promoLoading ? '...' : 'Apply'}
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* {
                            singleOrderInfo?.status==="DONE" &&
                           <div className="billing-input-field">
                              <p>Paid Amount</p>
                              <input
                                  placeholder="0.00"
                                  type="number"
                                  value={paymentForm?.amountPaid || ""}
                                  readOnly
                                  />
                          </div>} */}

                        </div>
                        <div
                            className="total-amount"
                        >
                            <div className="total">
                                {paymentForm?.totalExcl !== 0 &&
                                    <p>Exclusive Tax</p>}

                                {paymentForm?.totalIncl !== 0 &&
                                    <p >Inclusive Tax</p>
                                }
                                <p>Change</p>
                                <p style={{ color: "red" }}>Balance</p>
                                <h1>Total amount </h1>
                            </div>
                            <div className="total-a">
                                {
                                    paymentForm?.totalExcl !== 0 &&
                                    <p>{paymentForm?.totalExcl?.toFixed(decimalPosition)}</p>
                                }
                                {
                                    paymentForm?.totalIncl !== 0 &&
                                    <p>{paymentForm?.totalIncl?.toFixed(decimalPosition)}</p>}
                                <p>{paymentForm?.change}</p>
                                <p style={{ color: "red" }}>{paymentForm?.balance}</p>
                                <h1>{paymentForm?.amountTotal?.toFixed(decimalPosition)}</h1>
                            </div>
                        </div>
                        <Calculator />
                    </div>
                </div>
            </div>
            <div className="flex-column">

                <div className="payment-types-ctn">
                    <div className="payment-types-ctn-head justify-center">
                        Payment Method
                    </div>
                    <div className="payment-types-row-ctn">
                        {
                            paymentsTypeArray.length !== 0 ?
                                <div className={billingPaymentTypeView === 'card' ? 'payment-method-grid' : undefined}>
                                    {paymentsTypeArray.map((r, i) => {
                                        const typeKey = getPaymentTypeKey(r?.type);

                                        const isCardManual = cardManual !== undefined && cardManual?.filter((obj) => obj?.journalId === r?.journalId).length !== 0 && typeKey === "card";
                                        if (isCardManual) {
                                            const selected = isPaymentTypeSelected(r);
                                            return (
                                                <div
                                                    key={r?._id || r?.journalId || `${typeKey}-${i}`}
                                                    className={billingPaymentTypeView === 'card'
                                                        ? 'payment-method-card payment-method-card--autocomplete'
                                                        : 'payment-types-row payment-types-row-auto-complete payment-method-list'}
                                                >
                                                    <div className={billingPaymentTypeView === 'card' ? 'payment-method-card-inner' : 'payment-method-list-inner'}>
                                                        <div className="payment-method-icon">
                                                            {renderPaymentLottie(typeKey, billingPaymentTypeView === 'card' ? 42 : 28, selected)}
                                                        </div>
                                                        <div className={billingPaymentTypeView === 'card' ? 'payment-method-card-label' : 'payment-method-label'}>
                                                            {billingPaymentTypeView === 'card' ? 'CARD' : r?.journalName}
                                                        </div>
                                                    </div>
                                                    <Autocomplete
                                                        options={cardManual?.filter((obj) => obj?.journalId === r?.journalId) || []}
                                                        getOptionLabel={(option) => option?.cardName}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={r?.journalName}
                                                            />
                                                        )}
                                                        onChange={paymentCardOnchange(r)}
                                                        value={null}
                                                    />
                                                </div>
                                            )
                                        }

                                        const selected = isPaymentTypeSelected(r);
                                        const label = (r?.journalName || '').toUpperCase();

                                        if (billingPaymentTypeView === 'card') {
                                            return (
                                                <div
                                                    key={r?._id || r?.journalId || `${typeKey}-${i}`}
                                                    onClick={paymentTypeClick(r)}
                                                    className={`payment-method-card ${selected ? 'payment-method-card--selected' : ''}`}
                                                >
                                                    <div className="payment-method-card-check">
                                                        {selected ? <i className="bi bi-check2"></i> : null}
                                                    </div>
                                                    <div className="payment-method-icon">
                                                        {renderPaymentLottie(typeKey, 48, selected)}
                                                    </div>
                                                    <div className="payment-method-card-label">{label}</div>
                                                </div>
                                            )
                                        }

                                        return (
                                            <div
                                                key={r?._id || r?.journalId || `${typeKey}-${i}`}
                                                onClick={paymentTypeClick(r)}
                                                className={`payment-types-row payment-method-list ${selected ? 'payment-method-list--selected' : ''}`}
                                            >
                                                <div className="payment-method-list-inner">
                                                    <div className="payment-method-icon">
                                                        {renderPaymentLottie(typeKey, 28, selected)}
                                                    </div>
                                                    <span className="payment-method-label">{label}</span>
                                                </div>
                                                <div className="payment-method-list-right">
                                                    {selected ? <i className="bi bi-check2"></i> : null}
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {walletStatus && customerWallet && singleOrderInfo?.type !== "refund" && (
                                        (() => {
                                            const selected = isPaymentTypeSelected(cusWalletObj);
                                            return (
                                        billingPaymentTypeView === 'card' ? (
                                            <div
                                                onClick={paymentTypeClick(cusWalletObj)}
                                                className={`payment-method-card ${selected ? 'payment-method-card--selected' : ''}`}
                                            >
                                                <div className="payment-method-card-check">
                                                    {selected ? <i className="bi bi-check2"></i> : null}
                                                </div>
                                                <div className="payment-method-icon">
                                                    {renderPaymentLottie('cash', 48, selected)}
                                                </div>
                                                <div className="payment-method-card-label">WALLET</div>
                                                <div className="payment-method-card-sub">{cusWalletObj?.walletBalance?.toFixed(decimalPosition)}</div>
                                            </div>
                                        ) : (
                                            <div
                                                onClick={paymentTypeClick(cusWalletObj)}
                                                className={`payment-types-row payment-method-list ${selected ? 'payment-method-list--selected' : ''}`}
                                            >
                                                <div className="payment-method-list-inner">
                                                    <div className="payment-method-icon">
                                                        {renderPaymentLottie('cash', 28, selected)}
                                                    </div>
                                                    <span className="payment-method-label">{cusWalletObj?.journalName?.toUpperCase()}</span>
                                                </div>
                                                <div className="payment-method-list-right">
                                                    <span style={{ color: "#139109", fontWeight: "600" }}>
                                                        {cusWalletObj?.walletBalance?.toFixed(decimalPosition)}
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                            );
                                        })()
                                    )}
                                </div>
                                :
                                <div className="center-div">
                                    Payment Methods Not Added !!
                                </div>

                        }
                    </div>
                    <div className="payment-types-ctn-head justify-center">
                        Payment Selected
                    </div>
                    <div className="payment-types-row-ctn" style={{ flex: "1" }}>
                        {
                            paymentSelectedArray.length !== 0 ?
                                paymentSelectedArray.map((r, i) => {
                                    if (r?.change) return null;
                                    return (
                                        <div
                                            key={r?._id || r?.journalId || `${r?.type || 'pt'}-${i}`}
                                            onMouseLeave={handleMouseLeavePayment}
                                            onClick={paymentRowClick(i)}
                                            className="payment-types-row-list">
                                            <div className="payment-types-row">
                                                <p className='justify-center' style={{ gap: "4px" }}>
                                                    {/* {
                              cardManual!==undefined && r?.type==="card"?
                              <img
                                style={{height:"20px",width:"20px"}}
                                src={r?.imageUrl} alt="" />
                                :""
                                } */}
                                                    {r?.journalName?.toUpperCase()}
                                                </p>
                                                {r?.type === "card" &&
                                                    <>
                                                        <input
                                                            className='card-aproval-code'
                                                            type="text"
                                                            placeholder='Approval code'
                                                            onChange={approvalNoOnChange(i)}
                                                        />
                                                        {r?.posMachineEnabled && r?.posMachineProvider && (
                                                            <Tooltip title={`POS Machine: ${r.posMachineProvider === 'pinelab' ? 'Pine Labs' : r.posMachineProvider === 'paytm' ? 'Paytm' : 'Other'}`}>
                                                                <IconButton
                                                                    onClick={() => handlePosMachinePayment(r)}
                                                                    sx={{ 
                                                                        backgroundColor: "#4CAF50", 
                                                                        color: "#fff", 
                                                                        ml: 0.5,
                                                                        width: "30px",
                                                                        height: "30px",
                                                                        '&:hover': {
                                                                            backgroundColor: "#45a049"
                                                                        }
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    <CreditCardIcon sx={{width:"16px",height:"16px"}} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </>
                                                }
                                                {
                                                    r?.type === "upi" &&
                                                    <>
                                                        <PaymentQrComponent
                                                            label={"Scan to Pay via UPI"}
                                                            bankAccount={r?.upiId}
                                                            payeeName={r?.bankingName}
                                                            amount={r?.paidAmt}
                                                            onClick={() => handleClickQr(r)}
                                                            setCustomerDisplayQRInfo={setCustomerDisplayQRInfo}
                                                        />
                                                        {branchConfigurationList?.enableWhatsApp && customer?.mobileNo && (
                                                            <Tooltip title="Send UPI link via WhatsApp">
                                                                <IconButton
                                                                    onClick={() => sendUpiQrToWhatsApp(r)}
                                                                    sx={{ 
                                                                        backgroundColor: "#25D366", 
                                                                        color: "#fff", 
                                                                        ml: 0.5,
                                                                        width: "30px",
                                                                        height: "30px",
                                                                        '&:hover': {
                                                                            backgroundColor: "#128C7E"
                                                                        }
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    <WhatsAppIcon sx={{width:"16px",height:"16px"}} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </>}
                                                <div
                                                    className='justify-center'
                                                    style={{ justifyContent: "end", gap: "10px" }}
                                                >
                                                    <input
                                                        type='number'
                                                        className={selectedPaymentRow === i ? "editable" : undefined}
                                                        value={r?.paidAmt}
                                                        onChange={paidAmountChange(i)}
                                                        onFocus={(e) => e.target.select()}
                                                        onBlur={handleMouseLeavePayment}
                                                    />
                                                </div>
                                            </div>
                                            <button
                                                onClick={removePaymentType(i)}
                                            >
                                                <CloseIcon sx={{ color: "#fff" }} />
                                            </button>
                                        </div>
                                    );
                                })
                                :
                                <div className="center-div" style={{ height: "90%", flexDirection: "column" }}>
                                    <img src={paymentEmpty} alt="" style={{ width: "70%" }} />
                                    <p style={{margin:"0px"}}>Select a Payment Type</p>
                                </div>
                        }
 {paymentSelectedArray?.length === 0 && (
<div style={{width:"36%",alignSelf:"self-end",backgroundColor:"green",borderRadius:"8px",boxShadow:"0 2px 6px rgba(0, 0, 0, 0.15)"}}   onClick={() => {
    dispatch(setBtnSelected(null)); // this sets btnClicked to null
  }}>
    <p style={{color:"white",textAlign:"center"}}>Back to Cart</p></div>)}
                    </div>
                </div>
                <div className="payment-button-ctn">
                    {console.log('🎨 Rendering payment button area - kmRangeError:', kmRangeError)}
                    {kmRangeError && (
                        <div style={{
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffc107',
                            borderRadius: '4px',
                            padding: '10px 15px',
                            marginBottom: '10px',
                            color: '#856404',
                            fontSize: '14px',
                            textAlign: 'center',
                            fontWeight: '500'
                        }}>
                            ⚠️ {kmRangeError}
                        </div>
                    )}
                    <button
                        ref={paymentButtonRef}
                        onClick={singleOrderInfo?.type === "refund" ? refundOrderPayment : finalPlaceOrderValidations}
                        disabled={!!kmRangeError}
                        className="billing-placeOrder-button"
                        style={{
                            opacity: kmRangeError ? 0.5 : 1,
                            cursor: kmRangeError ? 'not-allowed' : 'pointer'
                        }}>
                        {upiPollingActive ? 'Waiting for UPI...' : 'Payment'}
                    </button>
                </div>
            </div>
            <Dialog open={dialogOpen === "walletChange"} onClose={walletCancelPopuo}>
                <div className='wallet-change-dialog'>
                    <div className="head justify-center">
                        <div className="icon justify-center">
                            <img src={walletIcon} alt="" />
                        </div>
                        Amount add wallet
                    </div>
                    <div className="input-ctn">
                        <button disabled className="btn">Change</button>
                        <input type="text"
                            value={paymentForm?.changeInWallet}
                            readOnly
                            placeholder={0?.toFixed(decimalPosition)}
                        />
                    </div>
                    <div className="input-ctn">
                        <button disabled className="btn">Wallet</button>
                        <input type="text"
                            value={paymentForm?.wallet}
                            onChange={amountAndWalletChange("wallet")}
                            placeholder={0?.toFixed(decimalPosition)}
                            onFocus={(e) => e.target.select()}
                        // onblur={handleMouseLeave}
                        />
                    </div>
                    <div className="wallet-change-btn">
                        <button
                            onClick={walletCancelPopuo}
                            className="btn-secondary-outlined btn">Cancel</button>
                        <button
                            onClick={payFromWallet}
                            className="btn-primary btn">Pay</button>
                    </div>
                </div>
            </Dialog>

            <Dialog open={dialogOpen === "discountAuthPassword"} onClose={() => dispatch(setDialogBox(false))}>
                <UpdateOrderAuth text={"Discount Authentication"} authType="discount" submitClick={finalPlaceOrder} />
            </Dialog>

            <div className='receipt-print-parent' style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
                <div ref={invoicePrint} className='pos-print-container'>
                    <PosReceiptTemplate />
                </div>
            </div>
        </div>
    )
}

export default BillingPayment